var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mu-button',{attrs:{"color":_vm.color || 'primary',"round":_vm.round ? _vm.round : false},on:{"click":_vm.exportExcel}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }